module.exports = __webpack_public_path__ + "media/customizations/viridian/logo-5a889f0eafa56f3b835e2cec3d7e8e49.png";